import { LOADED_THEME, SUPPORTED_THEMES } from '~persistence/theme';
import PLATFORMS from '~platform/platforms';
import { getPlatformThemeData } from '~platform/theme';
export function isSoikieTheme() {
    const themeId = Object.entries(SUPPORTED_THEMES).find(x => LOADED_THEME === x[1])?.[0];
    if (themeId === 'soikie-light') {
        return true;
    }
    return false;
}
export function getBasePlatform() {
    if (isSoikieTheme()) {
        return PLATFORMS.soikie;
    }
    const { platform } = getPlatformThemeData();
    return PLATFORMS[platform] || PLATFORMS.mipasa;
}
